import { Fragment, useMemo } from "react";
import ProjectAnnexHeader from "../ProjectAnnexHeader";
import DataTable, { DataTableColumn } from "@hpo/client/components/DataTable";
import { ServiceInstructor } from "@hpo/client/models/Expense";
import { Annex, ProjectInstructor } from "@hpo/client/models/Project";
import Spacer from "@hpo/client/utilities/Spacer";
import Units from "@hpo/client/utilities/Units";
import { getServerDateAsString } from "@hpo/client/utilities/helpers/DateHelper";
import { distpatchExpenses } from "@hpo/client/utilities/helpers/ExpenseHelper";

type ProjectTabServicesProps = {
  project: ProjectInstructor;
  annex: Annex;
  onReload: () => unknown;
};

export default function ProjectTabServices(props: ProjectTabServicesProps) {
  const { annex, onReload, project } = props;

  return (
    <Fragment>
      <ProjectAnnexHeader
        title="Récapitulatif des dépenses prévisionnelles - PRESTATIONS"
        annex={annex}
        onReload={onReload}
        project={project}
      />
      <Spacer />
      <ServicesList {...props} />
    </Fragment>
  );
}

function ServicesList(props: ProjectTabServicesProps) {
  const { project } = props;

  const servicesData = useMemo(
    () => distpatchExpenses(project.expenses).service,
    [project.expenses],
  );

  const columns: DataTableColumn<ServiceInstructor>[] = [
    {
      field: "label",
      header: "Intitulé",
    },
    {
      field: "provider",
      header: "Nom du prestataire",
    },
    {
      field: "quotationReference",
      header: "N° du devis",
    },
    {
      header: "Date du devis",
      body: (e) => {
        return getServerDateAsString(e.quotationDate);
      },
    },
    {
      header: "Cout total prévisionnel du devis / an",
      body: (e) => {
        return Units.euro.display(e.annualCost);
      },
    },
    {
      header: "Coût total prévisionnel du devis sur 3 ans",
      body: (e) => {
        return Units.euro.display(e.quotationTotalCost);
      },
    },
    {
      header:
        "Montant de l'aide éligilibe = coût du devis plafonné le cas échéant / an",
      body: (e) => {
        return Units.euro.display(e.helpAmountPerYear);
      },
    },
    {
      header: "Montant de l'aide éligible sur 3 ans",
      body: (e) => {
        return Units.euro.display(e.helpAmountThreeYears);
      },
    },
  ];

  return <DataTable value={servicesData} columns={columns} />;
}
